export const subscriptionConverter = {
  fromFirestore: (snapshot, options) => {
    const subscription = snapshot.data(options);
    const id = snapshot.id;

    return {
      _id: id,
      applicationId: subscription.application_id,
      cardId: subscription.card_id,
      frecuencyType: subscription.auto_recurring.frequency_type,
      freeTrial: subscription.auto_recurring.free_trial,
      payerEmail: subscription.payer_email,
      payerId: subscription.payer_id,
      paymentMethodId: subscription.payment_method_id,
      planId: subscription.preapproval_plan_id,
      renewsAt: subscription.next_payment_date,
      startDate: subscription.auto_recurring.start_date,
      status: subscription.status,
      subscriptionId: subscription.id,
      transaction: subscription.auto_recurring.transaction_amount,
    };
  },
  toFirestore: (subscription) => {
    delete subscription._id;
    return {
      application_id: subscription.applicationId,
      auto_recurring: {
        frequency_type: subscription.frecuencyType,
        free_trial: subscription.freeTrial,
        start_date: subscription.startDate,
        transaction_amount: subscription.transaction,
      },
      card_id: subscription.cardId,
      id: subscription.subscriptionId,
      next_payment_date: subscription.renewsAt,
      payer_email: subscription.payerEmail,
      payer_id: subscription.payerId,
      payment_method_id: subscription.paymentMethodId,
      preapproval_plan_id: subscription.planId,
      status: subscription.status,
    };
  },
};
